import { Config } from 'modules/config/state/config-types'
import { PaymentMethod, PaymentProcessor } from 'models/ChargeIntent'
import { PaymentDetails } from './payment-details-types'

export const makePaymentDetailsInitialState = (config: Config): PaymentDetails => {
  const hasDW = !!config.payment.activeMethods.find((m) => m.type === PaymentMethod.DW)

  return {
    method: null,
    isAmex: false,
    processor: PaymentProcessor.STRIPE,
    type: hasDW ? PaymentMethod.DW : PaymentMethod.CC,
  }
}
